<template>
  <g-master name="conversacion"
            :endpoint="shiftMaster.endpoint"
            :tableSetup="shiftMaster.tableSetup"
            :modalFieldsSetup="shiftMaster.modalFieldsSetup"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" label="Descripción">
            <a-input
              v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" label="Valor">
            <a-input
              v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" label="Valor real">
            <a-input
              v-decorator="['real_value', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    data() {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        shiftMaster: {
          endpoint: 'convertion',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_convertion'
            },
            columns: [
              {title: 'Descripcion', dataIndex: 'description', sorter: true},
              {title: 'Valor real', dataIndex: 'real_value', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true},
            ]
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'real_value'},
            {name: 'value'},
          ],
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Conversion.vue